module.exports = __webpack_public_path__ + "img/9788954618380.99cf4661.jpg";